import {apiGet, apiPost, apiPostWithRetry} from './client';

export function generateText({celebId, concept, details}) {
    return apiPostWithRetry('/celebs/generate-text', {
        celeb_id: celebId,
        concept,
        details,
    });
}

export function createVideoGeneration({celebId, wishText, accountId, audioUrl, useCredits = true}) {
    return apiPost('/celebs/generate', {
        celeb_id: celebId,
        wish_text: wishText,
        account_id: accountId,
        // Озвучка из прослушанного превью — именно она попадёт в видео.
        // Без неё (повторная генерация из заказов) бэкенд озвучит заново.
        audio_url: audioUrl || undefined,
        use_credits: useCredits,
    });
}

export function getGenerationStatus(jobId) {
    return apiGet(`/celebs/generate/${jobId}`);
}
